import { usePanelActions } from '@/shared/panel/store'

import NotificationPanel from '../components/panel'

export const useNotificationsPanel = () => {
	const { createPanel } = usePanelActions()

	const openNotificationsPanel = () => {
		createPanel({
			title: 'Notifications',
			render: () => <NotificationPanel />,
		})
	}

	return {
		open: openNotificationsPanel,
	}
}
